import React from 'react';
import Header from '../components/Header';
import FooterMinimal from '../components/FooterMinimal';
import { useTranslations } from '../translations/translations';
import { useLanguage, useLocalizedNavigate } from '../contexts/LanguageContext';

const AdvanceCoordinationPage = () => {
  const navigate = useLocalizedNavigate();
  const { language } = useLanguage();
  const t = useTranslations();

  return (
    <div className="App">
      <Header />
      <main style={{ background: '#000', minHeight: '100vh', paddingTop: '80px' }}>
        <section style={{
          padding: '8rem 0 4rem',
          borderBottom: '1px solid #1a1a1a'
        }}>
          <div className="container-custom">
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'transparent',
                border: '1px solid #262626',
                color: '#a3a3a3',
                padding: '0.75rem 1.5rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                marginBottom: '3rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#404040';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#262626';
                e.currentTarget.style.color = '#a3a3a3';
              }}
            >
              ← {language === 'fr' ? 'Retour' : 'Back'}
            </button>

            <div style={{
              fontSize: '0.8rem',
              letterSpacing: '3px',
              color: '#525252',
              marginBottom: '1.5rem',
              fontWeight: 500
            }}>
              SERVICE 03
            </div>

            <h1 style={{
              fontSize: 'clamp(1.9rem, 10vw, 4.5rem)',
              fontWeight: 300,
              marginBottom: '1rem',
              letterSpacing: '-0.02em',
              color: '#fff'
            }}>
              Supervision
            </h1>

            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: 400,
              marginBottom: '3rem',
              color: '#a3a3a3'
            }}>
              Supervision
            </h2>

            <p style={{
              fontSize: '1.1rem',
              color: '#737373',
              lineHeight: 1.8,
              maxWidth: '900px',
              fontWeight: 300
            }}>
              {t.coordination.intro}
            </p>
          </div>
        </section>

        <section style={{
          padding: '6rem 0',
          borderBottom: '1px solid #1a1a1a'
        }}>
          <div className="container-custom">
            <div style={{
              width: '100%',
              height: '700px',
              borderRadius: '8px',
              overflow: 'hidden',
              border: '1px solid #262626',
              position: 'relative',
              background: '#000'
            }}>
              <img 
                src="/images/altes/supervision-coordination.jpg"
                alt="Supervision et Coordination Opérationnelle - ALTES Protection"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
              />
            </div>
          </div>
        </section>

        <section style={{
          padding: '6rem 0'
        }}>
          <div className="container-custom">
            <div style={{
              maxWidth: '1200px'
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.coordination.coordination.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '4rem'
              }}>
                {t.coordination.coordination.text}
              </p>

              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.coordination.gestion.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300
              }}>
                {t.coordination.gestion.text}
              </p>
            </div>
          </div>
        </section>
      </main>
      <FooterMinimal />
    </div>
  );
};

export default AdvanceCoordinationPage;